import { Link } from "react-router-dom";

const LOGO_WHITE = "/brand/mtg_logo_white.svg";

export const PublicFooter = () => (
  <footer className="montempsgagne-bg-navy py-14 px-6 md:px-12" data-testid="public-footer">
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <div className="flex items-center gap-4">
        <img src={LOGO_WHITE} alt="MonTempsGagné" className="h-9" />
        <div className="h-8 w-px bg-white/20 hidden md:block"></div>
        <div className="text-sm text-white/80">Des devis automatiques. Plus de temps pour votre métier.</div>
      </div>
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs">
        <Link to="/tarifs" className="text-white/70 hover:text-white transition-colors" data-testid="footer-tarifs">Tarifs</Link>
        <Link to="/demo" className="text-white/70 hover:text-white transition-colors">Démo</Link>
        <Link to="/mentions-legales" className="text-white/70 hover:text-white transition-colors" data-testid="footer-legal">Mentions légales</Link>
        <Link to="/confidentialite" className="text-white/70 hover:text-white transition-colors" data-testid="footer-privacy">Confidentialité</Link>
        <Link to="/connexion" className="text-white/70 hover:text-white transition-colors">Espace professionnel</Link>
        <span className="text-white/40">© {new Date().getFullYear()} MonTempsGagné</span>
      </div>
    </div>
    <div className="max-w-6xl mx-auto mt-6 text-xs text-white/45">
      Réalisé avec cœur par <a href="https://flamingops.fr" rel="noopener noreferrer" className="text-white/70 hover:text-white underline underline-offset-2" data-testid="footer-flamingops">FlamingOps</a>
    </div>
  </footer>
);

export default PublicFooter;
